var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from './api.service';
import { ContentBaseService } from '../component/base/contentbase.service';
import { MenuService } from '../component/menu/menu.service';
import { ConditionService } from './condition.service';
import { TabService } from '../component/tab/tab.service';
var AuthenticationService = /** @class */ (function (_super) {
    __extends(AuthenticationService, _super);
    function AuthenticationService(logger, api, menu, cond, tab) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.menu = menu;
        _this.cond = cond;
        _this.tab = tab;
        return _this;
    }
    AuthenticationService.prototype.login = function (login, password) {
        var _this = this;
        return this.api.post('/v1/au-m/login', JSON.stringify({ login: login, pass: password }))
            .pipe(map(function (res) {
            // login successful if there's a jwt token in the response
            localStorage.setItem('currentUser', JSON.stringify(res));
            _this.menu.resetMenuOpenState();
            _this.cond.resetCondition();
            _this.tab.resetTab();
            // let user = response.json();
            // if (user && user.token) {
            // 	// store user details and jwt token in local storage to keep user logged in between page refreshes
            // 	localStorage.setItem('currentUser', JSON.stringify(user));
            // }
            if (_this.api.getIsStop()) {
                return null;
            }
            return res;
        }));
    };
    AuthenticationService.prototype.logout = function () {
        return this.api.post('/v1/au-m/logout', '{}').pipe(map(function (res) {
            // remove user from local storage to log user out
            localStorage.removeItem('currentUser');
        }));
    };
    AuthenticationService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AuthenticationService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: MenuService },
        { type: ConditionService },
        { type: TabService }
    ]; };
    return AuthenticationService;
}(ContentBaseService));
export { AuthenticationService };
//# sourceMappingURL=authentication.service.js.map